export default "__VITE_ASSET__BmlN846o__"